import { createSlice } from "@reduxjs/toolkit";

export const reviewSlice = createSlice({
  name: "review",
  initialState: {
    openVideoReview: true,
  },
  reducers: {
    openVideo: (state) => {
      state.openVideoReview = false;
    },
    closeVideo: (state) => {
      state.openVideoReview = true;
    },
  },
});

const { actions, reducer: reviewReducer } = reviewSlice;
export const { openVideo, closeVideo } = actions;
export default reviewReducer;
